import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

export function useShare() {
  const { t } = useTranslation();
  const [isSharing, setIsSharing] = useState(false);

  const shareProduct = useCallback(async (item, restaurantId, tableNumber, mode = 'dine_in') => {
    setIsSharing(true);

    // Build URL based on mode
    const baseUrl = window.location.origin;
    const url = mode === 'takeaway'
      ? `${baseUrl}/r/${restaurantId}/takeaway?item=${item.itemId}`
      : `${baseUrl}/r/${restaurantId}/t/${tableNumber}?item=${item.itemId}`;

    const itemName = item.name || item.translations?.es?.name || 'producto';
    const shareData = {
      title: itemName,
      text: t('share.productText', { name: itemName }),
      url: url
    };

    try {
      // Try native share first (mobile)
      if (navigator.share && navigator.canShare?.(shareData)) {
        await navigator.share(shareData);
        return { success: true, method: 'native' };
      } else {
        // Fallback to clipboard
        await navigator.clipboard.writeText(url);
        return { success: true, method: 'clipboard' };
      }
    } catch (error) {
      // User cancelled share (not an error)
      if (error.name === 'AbortError') {
        return { success: false, cancelled: true };
      }

      console.error('Share failed:', error);

      // Try clipboard as last resort
      try {
        await navigator.clipboard.writeText(url);
        return { success: true, method: 'clipboard' };
      } catch (clipboardError) {
        return { success: false, error: clipboardError };
      }
    } finally {
      setIsSharing(false);
    }
  }, [t]);

  return { shareProduct, isSharing };
}
